import { combineReducers } from 'redux';
import { businessReducer } from './business/reducer';
import { categoriesReducer } from './categories/reducer';
import { collectionsReducer } from './collections/reducer';
import { cpaReducer } from './cpa/reducer';
import { directReducer } from './direct/reducer';
import { experimentsReducer } from './experiments/reducer';
import { geoReducer } from './geo/reducer';
import { metaReducer } from './meta/reducer';
import { notificationsReducer } from './notifications/reducer';
import { postsReducer } from './posts/reducer';
import { productsReducer } from './products/reducer';
import { usersReducer } from './user/reducer';

export const rootReducer = combineReducers({
    posts: postsReducer,
    business: businessReducer,
    categories: categoriesReducer,
    notifications: notificationsReducer,
    users: usersReducer,
    collections: collectionsReducer,
    products: productsReducer,
    experiments: experimentsReducer,
    meta: metaReducer,
    direct: directReducer,
    geo: geoReducer,
    cpa: cpaReducer,
});
